import { ChangeDetectionStrategy, Component, Input, Optional } from '@angular/core';
import { OptionMenu } from '@shared/ui-components/options-menu/options-menu.model';
import { IconButtonComponent } from '@shared/ui-components/icon-button/icon-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { MatMenuModule } from '@angular/material/menu';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';
import { OptionsMenuDirective } from '@shared/ui-components/options-menu/options-menu.directive';

@Component({
  selector: 'ac-options-menu',
  standalone: true,
  imports: [IconButtonComponent, TranslateModule, IconComponent, MatMenuModule, CustomLinkDirective],
  template: `
    <ac-icon-button label="{{ 'GENERAL.OPEN_MENU' | translate }}" [matMenuTriggerFor]="menu">
      <ac-icon name="other-actions" size="small" />
    </ac-icon-button>
    <mat-menu #menu="matMenu" xPosition="before" class="!rounded-none border-solid border-black border">
      @for (option of options; track option.id) {
        <p class="px-2 py-1.5 hover:bg-gray-100 cursor-pointer" (click)="_executeAction(option)">{{ option.label | translate }}</p>
      } @empty {
        <p>{{ 'GENERAL.NO_DATA' | translate }}</p>
      }
    </mat-menu>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionsMenuComponent<MenuItem> {
  @Input({ required: true }) options!: OptionMenu<MenuItem>[];
  @Input() item?: MenuItem;
  constructor(@Optional() private readonly _optionsMenuDirective?: OptionsMenuDirective<MenuItem>) {}
  public _executeAction(option: OptionMenu<MenuItem>): void {
    const value = option.action(this.item);
    if (typeof value === 'string') {
      this._optionsMenuDirective?.actionExec.emit(option.id);
    }
  }
}
